import { BigNumber, BigNumberLike, bn } from "../../../utils/bn"

export const getClosestSmallerMultiple = (
  num: BigNumberLike,
  multiple: BigNumberLike,
) => {
  const multipleBn = bn(multiple)
  return multipleBn.times(
    bn(num).div(multipleBn).integerValue(BigNumber.ROUND_FLOOR),
  )
}

export const getClosestLargerMultiple = (
  num: BigNumberLike,
  multiple: BigNumberLike,
) => {
  const multipleBn = bn(multiple)
  return multipleBn.times(
    bn(num).div(multipleBn).integerValue(BigNumber.ROUND_CEIL),
  )
}
